import { forwardRef, type ForwardedRef, type SVGProps, FC } from 'react';

import { Button } from './Button';
import { type InternalProps as ButtonProps } from './Button.types';

export type Props = Omit<ButtonProps, 'startIcon' | 'endIcon' | 'isContentVisuallyHidden'> & {
  icon: FC<SVGProps<SVGSVGElement>>;
};

export const IconButton = forwardRef(function _IconButton(
  { icon, ...rest }: Props,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return <Button {...rest} startIcon={icon} ref={ref} isContentVisuallyHidden />;
});
